import Typography from '@mui/material/Typography';
import React from 'react';

import { SectionLabelProps } from './SectionLabel.props';
import { sectionLabelSx } from '../../../configs/detailPanelStyles';

/**
 * The small uppercase heading that groups fields inside a `Panel` — "ROUTE",
 * "REFERENCES", and so on. Several pages had grown their own copy of this
 * markup; this is the one they share.
 */
export const SectionLabel: React.FC<SectionLabelProps> = ({ children, mb = 1 }) => (
  <Typography component="h3" sx={{ ...sectionLabelSx, mb }}>
    {children}
  </Typography>
);
